module.exports = __webpack_public_path__ + "static/media/french-fries.2390ecfc.jpg";